
import {
    useCurationConfigValue
} from '../../../hooks/widgetConfiguration.js';

import {
    useLoadLandscapeListeningQuery
} from './useListeningQueryPersistence.js';


// This hook determines two things for the given propKey:
// 1. allSelectableIds: The ids of all selectable values for the given propKey. This is either the ids of the saved search or the ids of the values in the curation config.
// 2. currentlySelectedIds: The ids of the selected values for the given propKey. This is for when a user has futher filtered the saved search or the curation config values.
export default function useGetFilterSelectedIds(instanceId, propKey) {

    if (arguments.length === 1) {
        propKey = instanceId;
        instanceId = null;
    }

    const onlySelectableValues = useCurationConfigValue(instanceId, propKey);
    const selectedValue = useCurationConfigValue(instanceId, `selected${_.capitalize(propKey)}`);

    const listeningQueryId = useCurationConfigValue(instanceId, 'listeningQueryId');
    const {data: listeningQuery} = useLoadLandscapeListeningQuery(listeningQueryId);


    let allSelectableIds;
    if (listeningQuery) {
        allSelectableIds = listeningQuery.definition?.[propKey];
    } else {
        allSelectableIds = onlySelectableValues || null;
        if (_.isString(allSelectableIds)) {
            allSelectableIds = [allSelectableIds];
        }
    }

    let currentlySelectedIds = null;
    if (selectedValue) {
        if (_.isString(selectedValue)) {
            currentlySelectedIds = selectedValue.split(',');
        } else {
            currentlySelectedIds = selectedValue;
        }

        if (allSelectableIds) {
            currentlySelectedIds = _.intersection(currentlySelectedIds, allSelectableIds);

            if (_.isEmpty(currentlySelectedIds)) {
                currentlySelectedIds = allSelectableIds;
            }
        }
    }

    if (_.isEmpty(currentlySelectedIds)) {
        currentlySelectedIds = allSelectableIds;
    }

    return {
        allSelectableIds,
        currentlySelectedIds
    };
}
